import React from "react";

const Icon = (props) => {
  let s = (props.size != null ? props.size : "18") + "px";
  let c = "#fff";
  switch (props.color) {
    case "green":
      c = "#075819";
      break;
    case "red":
      c = "#8b0000";
      break;
    case "grey":
    default:
      c = "#444";
      break;
  }
  switch (props.icon) {
    case "Motion":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={s}
          viewBox="0 -960 960 960"
          width={s}
          fill={c}
        >
          <path d="M480-120q-17 0-28.5-11.5T440-160v-120q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280v120q0 17-11.5 28.5T480-120Zm311-129q-11 11-28 11t-28-11l-86-85q-12-12-12-28t12-28q12-12 28.5-12t28.5 12l85 85q11 11 11.5 27.5T791-249Zm-622 0q-11-11-11-28t11-28l85-86q12-12 28-12t28 12q12 12 12 28.5T310-334l-85 85q-11 11-27.5 11.5T169-249Zm155-391 12 40h288l12-40H324Zm12 120q-26 0-47-15.5T260-576l-20-64h-40q-33 0-56.5-23.5T120-720v-40q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v40q0 33-23.5 56.5T760-640h-40l-26 68q-9 23-29 37.5T620-520H336Z" />
        </svg>
      );
    case "Alarm":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={s}
          viewBox="0 -960 960 960"
          width={s}
          fill={c}
        >
          <path d="M480-260q17 0 28.5-11.5T520-300h-80q0 17 11.5 28.5T480-260Zm-140-60h280q8 0 14-6t6-14q0-8-6-14t-14-6h-20v-94q0-44-24-80t-66-46v-10q0-13-8.5-21.5T480-620q-13 0-21.5 8.5T450-590v10q-42 10-66 46t-24 80v94h-20q-8 0-14 6t-6 14q0 8 6 14t14 6ZM160-200v-360q0-19 8.5-36t23.5-28l240-180q11-8 23-12t25-4q13 0 25 4t23 12l240 180q15 11 23.5 28t8.5 36v360q0 33-23.5 56.5T720-120H240q-33 0-56.5-23.5T160-200Z" />
        </svg>
      );
    case "Door":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={s}
          viewBox="0 -960 960 960"
          width={s}
          fill={c}
        >
          <path d="M240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h480q33 0 56.5 23.5T800-800v640q0 33-23.5 56.5T720-80H240Zm380-340q25 0 42.5-17.5T680-480q0-25-17.5-42.5T620-540q-25 0-42.5 17.5T560-480q0 25 17.5 42.5T620-420Z" />
        </svg>
      );

    case "Lock":
      return (
        <svg
          fill={c}
          xmlns="http://www.w3.org/2000/svg"
          height={s}
          viewBox="0 -960 960 960"
          width={s}
        >
          <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z" />
        </svg>
      );

    case "Unlock":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={s}
          viewBox="0 -960 960 960"
          width={s}
          fill={c}
        >
          <path d="M240-640h360v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85h-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640Zm0 480h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM240-160v-400 400Z" />
        </svg>
      );

    case "led":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={s}
          viewBox="0 -960 960 960"
          width={s}
          fill={c}
        >
          <path d="M480-280q83 0 141.5-58.5T680-480q0-83-58.5-141.5T480-680q-83 0-141.5 58.5T280-480q0 83 58.5 141.5T480-280Zm0 200q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
        </svg>
      );

    case "Loading":
      return (
        <svg
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
          style={{
            shapeRendering: "auto",
            display: "block",
            background: "rgba(255, 255, 255, 0)",
            width: s,
            height: s,
          }}
        >
          <g>
            <circle fill="#007ee5" r="10" cy="50" cx="84">
              <animate
                begin="0s"
                keySplines="0 0.5 0.5 1"
                values="10;0"
                keyTimes="0;1"
                calcMode="spline"
                dur="1s"
                repeatCount="indefinite"
                attributeName="r"
              ></animate>
              <animate
                begin="0s"
                values="#007ee5;#3d464d;#47525d;#7b8994;#007ee5"
                keyTimes="0;0.25;0.5;0.75;1"
                calcMode="discrete"
                dur="4s"
                repeatCount="indefinite"
                attributeName="fill"
              ></animate>
            </circle>
            <circle fill="#007ee5" r="10" cy="50" cx="16">
              <animate
                begin="0s"
                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                values="0;0;10;10;10"
                keyTimes="0;0.25;0.5;0.75;1"
                calcMode="spline"
                dur="4s"
                repeatCount="indefinite"
                attributeName="r"
              ></animate>
              <animate
                begin="0s"
                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                values="16;16;16;50;84"
                keyTimes="0;0.25;0.5;0.75;1"
                calcMode="spline"
                dur="4s"
                repeatCount="indefinite"
                attributeName="cx"
              ></animate>
            </circle>
            <circle fill="#7b8994" r="10" cy="50" cx="50">
              <animate
                begin="-1s"
                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                values="0;0;10;10;10"
                keyTimes="0;0.25;0.5;0.75;1"
                calcMode="spline"
                dur="4s"
                repeatCount="indefinite"
                attributeName="r"
              ></animate>
              <animate
                begin="-1s"
                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                values="16;16;16;50;84"
                keyTimes="0;0.25;0.5;0.75;1"
                calcMode="spline"
                dur="4s"
                repeatCount="indefinite"
                attributeName="cx"
              ></animate>
            </circle>
            <circle fill="#47525d" r="10" cy="50" cx="84">
              <animate
                begin="-2s"
                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                values="0;0;10;10;10"
                keyTimes="0;0.25;0.5;0.75;1"
                calcMode="spline"
                dur="4s"
                repeatCount="indefinite"
                attributeName="r"
              ></animate>
              <animate
                begin="-2s"
                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                values="16;16;16;50;84"
                keyTimes="0;0.25;0.5;0.75;1"
                calcMode="spline"
                dur="4s"
                repeatCount="indefinite"
                attributeName="cx"
              ></animate>
            </circle>
            <circle fill="#3d464d" r="10" cy="50" cx="16">
              <animate
                begin="-3s"
                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                values="0;0;10;10;10"
                keyTimes="0;0.25;0.5;0.75;1"
                calcMode="spline"
                dur="4s"
                repeatCount="indefinite"
                attributeName="r"
              ></animate>
              <animate
                begin="-3s"
                keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
                values="16;16;16;50;84"
                keyTimes="0;0.25;0.5;0.75;1"
                calcMode="spline"
                dur="4s"
                repeatCount="indefinite"
                attributeName="cx"
              ></animate>
            </circle>
            <g></g>
          </g>
        </svg>
      );
    case "Refresh":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={s}
          viewBox="0 -960 960 960"
          width={s}
          fill={c}
        >
          <path d="M160-160v-80h110l-16-14q-52-46-73-105t-21-119q0-111 66.5-197.5T400-790v84q-72 26-116 88.5T240-478q0 45 17 87.5t53 78.5l10 10v-98h80v240H160Zm400-10v-84q72-26 116-88.5T720-482q0-45-17-87.5T650-648l-10-10v98h-80v-240h240v80H690l16 14q49 49 71.5 106.5T800-482q0 111-66.5 197.5T560-170Z" />
        </svg>
      );
    default:
      // Uknown Icon
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={s}
          viewBox="0 -960 960 960"
          width={s}
          fill={c}
        >
          <path d="M140-440q-25 0-42.5-17.5T80-500q0-25 17.5-42.5T140-560h240q25 0 42.5 17.5T440-500q0 25-17.5 42.5T380-440H140Zm440 0q-25 0-42.5-17.5T520-500q0-25 17.5-42.5T580-560h240q25 0 42.5 17.5T880-500q0 25-17.5 42.5T820-440H580Z" />
        </svg>
      );
  }
};

export default Icon;
